const PARQUE_CERRADO = "parque-cerrado";
let PARQUE_ABIERTO = "parque-abierto";
const LABEL_CERRADO = "Parque Cerrado";
const LABEL_ABIERTO = "parque abierto";
let LABEL_DISPONIBLE = "pasaporte disponible";
const LABEL_NO_DISPONIBLE = "pasaporte no disponible";
const PASAPORTE_NO_DISPONIBLE = "sin-pasporte";
const FORMATO_FECHA_CALENDARIO = "m/d/yy";
const MAXIMO_FECHAS_MOSTRAR = new Date(new Date().getFullYear() + 0, 11, 31); // Hasta el 31 de diciembre de este año
//const MAXIMO_FECHAS_MOSTRAR = new Date(new Date().getFullYear() + 1, 11, 31); // Hasta el 31 de diciembre del próximo año
let fechasDeshabilitadas = [];
let fechasPasaporte = [];
let colorPasaporte = "#B7B7B7";
let isOpen=false;

const UrlsPasaporte ={

  FECHAS_TRAVESIA : "https://grupopanaca.com.co/webapi/api/travesiashow",
 // FECHAS_NATURA : "https://grupopanaca.com.co/webapi/api/NaturaFechas",
 // FECHAS_GRANJERO : "https://grupopanaca.com.co/webapi/api/EventosFechasCalendario?id=119",
  FECHAS_TERRA : "https://grupopanaca.com.co/webapi/api/EventosFechasCalendario?id=101",
 
  
}

const ClasesPasaporte={

     ABIERTO:"parque-abierto",
     TRAVESIA :"pasaporte-travesia",
     NATURA : "pasaporte-natura",
     TERRA : "pasaporte-terra",
     TERRA_NINO : "pasaporte-terra-nino",
     GRANJERO : "pasaporte-granjero",
     CAMPO:    "pasaporte-campo",
     TERRA_NATURA :"pasaporte-natura",
}

const IdsPasaportes={
  ABIERTO:"8561612685531a",
  TERRA: "8561612685531",
  TRAVESIA: "8561613471963",
  NATURA  : "8561616388315",
  GRANJERO : "8680180711643",
  INFANTIL :  "8675970285787",
  CAMPO : "8561615274203",
  CAMPOINFANTIL : "8752678502619",
  TERRA_NATURA : "8561617535195",
  
}

const ColorPasaporte={
    TERRA:"#116736",
    TERRA_NINO : "#EC890A",
    NATURA : "#116736",
    TRAVESIA : "#AC6B3A",
    GRANJERO : "#E2725B",
    ABIERTO: "#FFF",
}

const Pasaportes ={

    ABIERTO:"Parque Abierto",
    TERRA :"Pasaporte Terra",
    TERRA_NINO :"Pasaporte Terra Niño",
    NATURA : "Pasaporte Natura",
    TRAVESIA : "Pasaporte Travesía",
    GRANJERO : "Pasaporte Granjero",
    CAMPO : "Pasaporte Campo",
    TERRA_NATURA : "Pasaporte Terra + Natura",
}

function formatearFecha(fecha) {
  const year = fecha.getFullYear();
  const month = String(fecha.getMonth() + 1).padStart(2, '0');
  const day = String(fecha.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
  
}

async function  diaCerrado() {
  fechasDeshabilitadas=[];
  try{ 
    const respuesta = await fetch('https://grupopanaca.com.co/webapi/api/EventosFechasCalendario?id=101');
    const json = await respuesta.json();
   
    const fechasConvertidas = json.map((item) => {
        if (item.Fecha) {
            const [mes, dia, anio] = item.Fecha.split('/');
            return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        } else {
          return null; 
       }
      
  });
  
  fechasDeshabilitadas = [...fechasConvertidas ];
  
  }catch(error){
    console.log("ocurrio el siguiente error", error);
  }
}

function  ocultarModal() {

  const modal = document.querySelector("#myModal");
  let select = document.querySelector(".contenedor-eventos__select").value;
  let prueba = document.querySelector(`#pspt${select}`);
  ocultarChat();
  modal.style.display = 'none';
}

function verificarDisponibilidad(date) {
  
    const fechaActual = new Date();
    fechaActual.setHours(0, 0, 0, 0); 

    const formattedDate = formatearFecha(date);

    if (date < fechaActual) {
        return [true, 'fecha-anterior', 'Fecha Anterior'];
    }

    
    if (fechasDeshabilitadas.includes(formattedDate)) {
        return [false, PARQUE_CERRADO, LABEL_CERRADO]; 
    } else {
        return [true, PARQUE_ABIERTO, LABEL_ABIERTO]; 
    }
}

function eventosCalendario(dateText, inst){
  const pasaportes = document.querySelectorAll(".section-pasaportes__slide-card");
  const fechaVisita = document.querySelector(".section-pasaportes__titulo-principal");
        pasaportes.forEach((pasaporte) => pasaporte.setAttribute("data-fecha", dateText));
        validarPasaportes(dateText);
        fechaVisita.textContent = obtnerFechaLarga(dateText);
        //obtenerCantidadProductos();
        ocultarModal();
        validationPassport()
}

function configuracionesCalendario(){
  return{
      dateFormat: FORMATO_FECHA_CALENDARIO,
      changeMonth: true,     
      changeYear: true,       
      minDate: new Date(),    
      maxDate: MAXIMO_FECHAS_MOSTRAR,
      beforeShowDay:verificarDisponibilidad,
      onSelect:eventosCalendario,
      language: 'es'
  }
}

async function inicializarDatepicker() {
    await diaCerrado();
    let configuraciones = await configuracionesCalendario();
    $("#datepicker").datepicker(configuraciones);
}

async function obtenerFechas(url){

    try{
       const respuesta = await fetch(url);

      if(!respuesta.ok){
        if (respuesta.status === 404) {
              throw new Error('404 Not Found');
        } else {
           throw new Error(`Error: ${respuesta.status} ${respuesta.statusText}`);
        }

      }
       const json = await respuesta.json();
     
       return json;
      
    }catch(error){
       console.log("ocurrio el siguiete error", error.message);
      return   '404 Not Found';
    }
    
  }

async function validarPasaportes(fecha){
  
   // await validarFechasDisponibilidadPasaporte(fecha, UrlsPasaporte.FECHAS_NATURA,  IdsPasaportes.NATURA);
   // await validarFechasDisponibilidadPasaporte(fecha, UrlsPasaporte.FECHAS_NATURA, IdsPasaportes.TERRA_NATURA);
   
    await validarFechasDisponibilidadPasaporte(fecha, UrlsPasaporte.FECHAS_TRAVESIA, IdsPasaportes.TRAVESIA);
    await validarFechasDisponibilidadPasaporte(fecha, UrlsPasaporte.FECHAS_TRAVESIA, IdsPasaportes.CAMPOINFANTIL);
    await validarFechasDisponibilidadPasaporte(fecha, UrlsPasaporte.FECHAS_TRAVESIA, IdsPasaportes.CAMPO);
 

  }

function obtnerFechaLarga(fecha){
  
  const fechaLarg = new Date(fecha);
  
  const opciones = { 
    day: 'numeric', 
    month: 'long', 
    year: 'numeric'
  };

  const fechaFormateada = fechaLarg.toLocaleDateString('es-ES', opciones);
  
  return fechaFormateada;
}

async function validarFechasDisponibilidadPasaporte(fecha, Urlfechas, idcontendorPasaporte){

  fecha = fecha.replaceAll("-", "/");

  const fechaPasaporte = await obtenerFechas(Urlfechas);
  const contenedorPasporte = document.getElementById(`pspt_${idcontendorPasaporte}`);
  const pasaporteSlideMovil = document.querySelector(".slide-activo");
  let fechaValida = await  fechaPasaporte.find((item)=>item.Fecha == fecha); 

    
   if(!fechaValida){
       contenedorPasporte.style.setProperty('display', "none");
    }else{
        contenedorPasporte.style.setProperty('display', "flex");
    }

 
  if (window.innerWidth < 480) {
    if (pasaporteSlideMovil) {
        //contenedorPasporte.style.setProperty('display', 'none');
        return;
      } 
  }
 popaup();
  
}

function cargarCalendario() {
  debugger;
  document.addEventListener('DOMContentLoaded', ()=>{
     const modal = document.querySelector('.modal');
    modal.style.setProperty('display', 'flex');
    // inicializarDatepicker();
  });
}

async function fechasDisponibilidadPasaporte(idpasaporte){

  const nomenclatura = document.querySelector(".color-nomenclatura__cerrado");
  const nomenclaturaSinpasaporte = document.querySelectorAll(".color-nomenclatura__cerrado");
  const nombrePasaporte = document.querySelector(".etiqueta-nomenclatura");
  const diaSinPasporte = document.querySelector(".color-nomenclatura__abierto");

  const nomenclaturaCerrado = document.querySelector(".fila_nomeclatur_cerrar");
  const PasaporteNoDisponible = document.querySelectorAll(".etiqueta-nomenclatura");
  PasaporteNoDisponible[1].textContent =LABEL_CERRADO;

  const nomenClaturaOculta = document.querySelector(".fila-nomenclatura__oculto");
  
  
  nomenclatura.style.setProperty("background-color", "#fff");
  diaSinPasporte.style.setProperty("background-color", "red");
  fechasDeshabilitadas = [];
  fechasPasaporte = [];
  let fechas = "";
  let isTerra=false;
  


   switch(idpasaporte){
      
     
     case  IdsPasaportes.TRAVESIA:
           //fechas = await obtenerFechas(UrlsPasaporte.FECHAS_TRAVESIA);
           fechas = [
  {
    "Fecha": "3/22/2025"
  },
  {
    "Fecha": "3/23/2025"
  },
  {
    "Fecha": "3/27/2025"
  },
  {
    "Fecha": "3/29/2025"
  },
  {
    "Fecha": "4/1/2025"
  },
  {
    "Fecha": "4/3/2025"
  },
  {
    "Fecha": "4/5/2025"
  },
  {
    "Fecha": "4/8/2025"
  },
  {
    "Fecha": "4/10/2025"
  },
  {
    "Fecha": "4/12/2025"
  },
  {
    "Fecha": "4/13/2025"
  },
  {
    "Fecha": "4/14/2025"
  },
  {
    "Fecha": "4/15/2025"
  },
  {
    "Fecha": "4/16/2025"
  },
  {
    "Fecha": "4/17/2025"
  },
  {
    "Fecha": "4/18/2025"
  },
  {
    "Fecha": "4/19/2025"
  },
  {
    "Fecha": "4/29/2025"
  },
  {
    "Fecha": "5/1/2025"
  },
  {
    "Fecha": "5/3/2025"
  },
  {
    "Fecha": "5/6/2025"
  },
  {
    "Fecha": "5/8/2025"
  },
  {
    "Fecha": "5/10/2025"
  },
  {
    "Fecha": "5/13/2025"
  },
  {
    "Fecha": "5/15/2025"
  },
  {
    "Fecha": "5/17/2025"
  },
  {
    "Fecha": "5/20/2025"
  },
  {
    "Fecha": "5/22/2025"
  },
  {
    "Fecha": "5/24/2025"
  },
  {
    "Fecha": "5/27/2025"
  },
  {
    "Fecha": "5/29/2025"
  },
  {
    "Fecha": "5/31/2025"
  },
  {
    "Fecha": "6/5/2025"
  },
  {
    "Fecha": "6/7/2025"
  },
  {
    "Fecha": "6/10/2025"
  },
  {
    "Fecha": "6/12/2025"
  },
  {
    "Fecha": "6/14/2025"
  },
  {
    "Fecha": "6/17/2025"
  },
  {
    "Fecha": "6/18/2025"
  },
  {
    "Fecha": "6/19/2025"
  },
  {
    "Fecha": "6/20/2025"
  },
  {
    "Fecha": "6/21/2025"
  },
  {
    "Fecha": "6/22/2025"
  },
  {
    "Fecha": "6/23/2025"
  },
  {
    "Fecha": "6/25/2025"
  },
  {
    "Fecha": "6/26/2025"
  },
  {
    "Fecha": "6/27/2025"
  },
  {
    "Fecha": "6/28/2025"
  },
  {
    "Fecha": "6/29/2025"
  },
  {
    "Fecha": "6/30/2025"
  },
  {
    "Fecha": "7/2/2025"
  },
  {
    "Fecha": "7/3/2025"
  },
  {
    "Fecha": "7/4/2025"
  },
  {
    "Fecha": "7/5/2025"
  },
  {
    "Fecha": "7/6/2025"
  },
  {
    "Fecha": "7/8/2025"
  },
  {
    "Fecha": "7/9/2025"
  },
  {
    "Fecha": "7/10/2025"
  },
  {
    "Fecha": "7/11/2025"
  },
  {
    "Fecha": "7/12/2025"
  },
  {
    "Fecha": "7/13/2025"
  },
  {
    "Fecha": "7/15/2025"
  },
  {
    "Fecha": "7/16/2025"
  },
  {
    "Fecha": "7/17/2025"
  },
  {
    "Fecha": "7/18/2025"
  },
  {
    "Fecha": "7/19/2025"
  },
  {
    "Fecha": "7/29/2025"
  },
  {
    "Fecha": "7/31/2025"
  },
  {
    "Fecha": "8/2/2025"
  },
  {
    "Fecha": "8/5/2025"
  },
  {
    "Fecha": "8/7/2025"
  },
  {
    "Fecha": "8/9/2025"
  },
  {
    "Fecha": "8/12/2025"
  },
  {
    "Fecha": "8/14/2025"
  },
  {
    "Fecha": "8/16/2025"
  },
  {
    "Fecha": "8/17/2025"
  },
  {
    "Fecha": "8/21/2025"
  },
  {
    "Fecha": "8/23/2025"
  },
  {
    "Fecha": "8/26/2025"
  },
  {
    "Fecha": "8/28/2025"
  },
  {
    "Fecha": "8/30/2025"
  },
  {
    "Fecha": "9/2/2025"
  },
  {
    "Fecha": "9/4/2025"
  },
  {
    "Fecha": "9/6/2025"
  },
  {
    "Fecha": "9/9/2025"
  },
  {
    "Fecha": "9/11/2025"
  },
  {
    "Fecha": "9/13/2025"
  },
  {
    "Fecha": "9/16/2025"
  },
  {
    "Fecha": "9/18/2025"
  },
  {
    "Fecha": "9/20/2025"
  },
  {
    "Fecha": "9/23/2025"
  },
  {
    "Fecha": "9/25/2025"
  },
  {
    "Fecha": "9/27/2025"
  },
  {
    "Fecha": "9/30/2025"
  },
  {
    "Fecha": "10/4/2025"
  },
  {
    "Fecha": "10/5/2025"
  },
  {
    "Fecha": "10/6/2025"
  },
  {
    "Fecha": "10/7/2025"
  },
  {
    "Fecha": "10/8/2025"
  },
  {
    "Fecha": "10/9/2025"
  },
  {
    "Fecha": "10/10/2025"
  },
  {
    "Fecha": "10/11/2025"
  },
  {
    "Fecha": "10/12/2025"
  },
  {
    "Fecha": "10/21/2025"
  },
  {
    "Fecha": "10/23/2025"
  },
  {
    "Fecha": "10/25/2025"
  },
  {
    "Fecha": "10/28/2025"
  },
  {
    "Fecha": "10/30/2025"
  },
  {
    "Fecha": "11/1/2025"
  },
  {
    "Fecha": "11/2/2025"
  },
  {
    "Fecha": "11/6/2025"
  },
  {
    "Fecha": "11/8/2025"
  },
  {
    "Fecha": "11/11/2025"
  },
  {
    "Fecha": "11/13/2025"
  },
  {
    "Fecha": "11/15/2025"
  },
  {
    "Fecha": "11/16/2025"
  },
  {
    "Fecha": "11/20/2025"
  },
  {
    "Fecha": "11/22/2025"
  },
  {
    "Fecha": "11/25/2025"
  },
  {
    "Fecha": "11/27/2025"
  },
  {
    "Fecha": "11/29/2025"
  },
  {
    "Fecha": "12/2/2025"
  },
  {
    "Fecha": "12/4/2025"
  },
  {
    "Fecha": "12/6/2025"
  },
  {
    "Fecha": "12/12/2025"
  },
  {
    "Fecha": "12/13/2025"
  },
  {
    "Fecha": "12/16/2025"
  },
  {
    "Fecha": "12/17/2025"
  },
  {
    "Fecha": "12/18/2025"
  },
  {
    "Fecha": "12/19/2025"
  },
  {
    "Fecha": "12/20/2025"
  },
  {
    "Fecha": "12/21/2025"
  },
  {
    "Fecha": "12/23/2025"
  },
  {
    "Fecha": "12/26/2025"
  },
  {
    "Fecha": "12/27/2025"
  },
  {
    "Fecha": "12/28/2025"
  }
]
           let etiqueta =  nombrePasaporte.parentNode.firstElementChild;
           etiqueta.style.setProperty('background-image', 'url("https://cdn.shopify.com/s/files/1/0607/8726/1659/files/miniatura_cb095494-adc7-4c31-936b-db899c0015df.png")');
           etiqueta.style.setProperty("width", "50px");
           etiqueta.style.setProperty("height", "40px");
           etiqueta.style.setProperty("background-repeat", "no-repeat");
           etiqueta.classList.add("logo-travesia");
           etiqueta.style.setProperty("border", "none");
           nombrePasaporte.style.setProperty("margin-top", "15px");
            nombrePasaporte.textContent= "Travesia 2.0";
           colorPasaporte = ClasesPasaporte.TRAVESIA;
         
           nomenClaturaOculta.style.setProperty("opacity", 1);
            LABEL_DISPONIBLE = Pasaportes.TRAVESIA;
      
          
       break
    case IdsPasaportes.ABIERTO:
        fechas = await obtenerFechas(UrlsPasaporte.FECHAS_TERRA );
         fechas = [
  {
    "Fecha": "3/25/2025"
  },
  {
    "Fecha": "3/31/2025"
  },
  {
    "Fecha": "4/7/2025"
  },
  {
    "Fecha": "4/21/2025"
  },
  {
    "Fecha": "4/28/2025"
  },
  {
    "Fecha": "5/5/2025"
  },
  {
    "Fecha": "5/12/2025"
  },
  {
    "Fecha": "5/19/2025"
  },
  {
    "Fecha": "5/26/2025"
  },
  {
    "Fecha": "6/3/2025"
  },
  {
    "Fecha": "6/9/2025"
  },
  {
    "Fecha": "6/16/2025"
  },
  {
    "Fecha": "7/21/2025"
  },
  {
    "Fecha": "7/28/2025"
  },
  {
    "Fecha": "8/4/2025"
  },
  {
    "Fecha": "8/11/2025"
  },
  {
    "Fecha": "8/19/2025"
  },
  {
    "Fecha": "8/25/2025"
  },
  {
    "Fecha": "9/1/2025"
  },
  {
    "Fecha": "9/8/2025"
  },
  {
    "Fecha": "9/15/2025"
  },
  {
    "Fecha": "9/22/2025"
  },
  {
    "Fecha": "9/29/2025"
  },
  {
    "Fecha": "10/14/2025"
  },
  {
    "Fecha": "10/20/2025"
  },
  {
    "Fecha": "10/27/2025"
  },
  {
    "Fecha": "11/4/2025"
  },
  {
    "Fecha": "11/10/2025"
  },
  {
    "Fecha": "11/18/2025"
  },
  {
    "Fecha": "11/24/2025"
  },
  {
    "Fecha": "12/1/2025"
  },
  {
    "Fecha": "12/9/2025"
  },
  {
    "Fecha": "12/15/2025"
  }
]
         nombrePasaporte.textContent = Pasaportes.ABIERTO;
         nomenclatura.style.setProperty("background-color",  ColorPasaporte.ABIERTO);
         colorPasaporte = ClasesPasaporte.ABIERTO;
       PARQUE_ABIERTO = "parque-abierto";
         isTerra=true;
         isOpen=true;
         LABEL_DISPONIBLE = Pasaportes.ABIERTO;
       
         nomenClaturaOculta.style.setProperty("opacity", 0);
      
       break;
       
     default:
       
       //  fechas = await obtenerFechas(UrlsPasaporte.FECHAS_TERRA);
         fechas = [
  {
    "Fecha": "3/25/2025"
  },
  {
    "Fecha": "3/31/2025"
  },
  {
    "Fecha": "4/7/2025"
  },
  {
    "Fecha": "4/21/2025"
  },
  {
    "Fecha": "4/28/2025"
  },
  {
    "Fecha": "5/5/2025"
  },
  {
    "Fecha": "5/12/2025"
  },
  {
    "Fecha": "5/19/2025"
  },
  {
    "Fecha": "5/26/2025"
  },
  {
    "Fecha": "6/3/2025"
  },
  {
    "Fecha": "6/9/2025"
  },
  {
    "Fecha": "6/16/2025"
  },
  {
    "Fecha": "7/21/2025"
  },
  {
    "Fecha": "7/28/2025"
  },
  {
    "Fecha": "8/4/2025"
  },
  {
    "Fecha": "8/11/2025"
  },
  {
    "Fecha": "8/19/2025"
  },
  {
    "Fecha": "8/25/2025"
  },
  {
    "Fecha": "9/1/2025"
  },
  {
    "Fecha": "9/8/2025"
  },
  {
    "Fecha": "9/15/2025"
  },
  {
    "Fecha": "9/22/2025"
  },
  {
    "Fecha": "9/29/2025"
  },
  {
    "Fecha": "10/14/2025"
  },
  {
    "Fecha": "10/20/2025"
  },
  {
    "Fecha": "10/27/2025"
  },
  {
    "Fecha": "11/4/2025"
  },
  {
    "Fecha": "11/10/2025"
  },
  {
    "Fecha": "11/18/2025"
  },
  {
    "Fecha": "11/24/2025"
  },
  {
    "Fecha": "12/1/2025"
  },
  {
    "Fecha": "12/9/2025"
  },
  {
    "Fecha": "12/15/2025"
  }
]
         nombrePasaporte.textContent = Pasaportes.TERRA;
         nomenclatura.style.setProperty("background-color",  ColorPasaporte.TERRA);
         colorPasaporte = ClasesPasaporte.TERRA;
         PARQUE_ABIERTO = "pasaporte-terra";
         isTerra=true;       
         diaSinPasporte.style.setProperty("background-color", "red");                
         nomenClaturaOculta.style.setProperty("opacity", 0);
       break;
       
   }


  let fechasConvertidas = await formatoFehcaMesDiaAnio(fechas)
  fechasDeshabilitadas = [...fechasConvertidas ];
 
  fechasPasaporte  = [...fechasConvertidas ];
  renderizarCalendario(isTerra);

}

function formatoFehcaMesDiaAnio(fechas) {
 
   return fechas.map((item) => {
        if (item.Fecha) {
            const [mes, dia, anio] = item.Fecha.split('/');
            return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        } else {
          return null; 
       }
      
  });
}

function fechasNodisponible(date) {

  const fechaActual = new Date();
  fechaActual.setHours(0, 0, 0, 0); 
  const formattedDate = formatearFecha(date);

  
 if (fechasDeshabilitadas.includes(formattedDate)) {
        return [false, PARQUE_CERRADO, LABEL_CERRADO]; 
    }

    // Verificar si la fecha es anterior a la actual
    if (date < fechaActual) {
        return [true, 'fecha-anterior', 'Fecha Anterior']; 
    }

    
    const esFechaPermitida = fechasPasaporte.some(fecha => {
        let arrayfecha = fecha.split("-");
        let anio = parseInt(arrayfecha[0], 10);
        let mes = parseInt(arrayfecha[1], 10) - 1; 
        let dia = parseInt(arrayfecha[2], 10);

       
        return date.getDate() === dia &&
               date.getMonth() === mes &&
               date.getFullYear() === anio;
    });

  
    return esFechaPermitida
        ? [true, colorPasaporte, LABEL_DISPONIBLE]  
        : [true, PASAPORTE_NO_DISPONIBLE,  LABEL_ABIERTO]; 
}

async function esFechaEnArray(date, arrayFechas) {
    return arrayFechas.some(fecha => {
        let arrayFecha = fecha.split("-");
        let anio = parseInt(arrayFecha[0], 10);
        let mes = parseInt(arrayFecha[1], 10) - 1; // Mes en base 0
        let dia = parseInt(arrayFecha[2], 10);

        return date.getDate() === dia &&
               date.getMonth() === mes &&
               date.getFullYear() === anio;
    });
}

async function renderizarCalendario(terra){

  let agregarClases = "";
  
  if(terra){
      agregarClases =await  verificarDisponibilidad;
  
    }else{
      await diaCerrado();
      agregarClases = await fechasNodisponible;
    }

     $('#datepicker').datepicker('destroy');
     $('#datepicker').datepicker({
          dateFormat: FORMATO_FECHA_CALENDARIO,
          changeMonth: true,     
          changeYear: true,       
          language: 'es',  
          minDate: new Date(),    
          maxDate: MAXIMO_FECHAS_MOSTRAR,
          beforeShowDay: agregarClases,
          onSelect:eventosCalendario,
      });
  
}

function clicksCalendarioPasaportes(){
  document.addEventListener('change', (event)=>{
    switch(true){
      case event.target.matches('.contenedor-eventos__select'):
         //fechasDisponibilidadPasaporte(IdsPasaportes.TERRA);
        fechasDisponibilidadPasaporte(event.target.value);
        break;

      
    }
  });
}

function clicsksDocument(){
   document.addEventListener('click', (event)=>{
    switch(true){
      case event.target.matches('.buttonCompraAhoraHeader, .section-pasaportes__redirecion'):   
        location.reload();
        break;

      
    }
  });
}

function ocultarChat() {
 var chatButton = document.querySelector("button.chat-toggle.chat-toggle--icon-button");
    if (chatButton) {
        chatButton.style.display = "none";
       
    }
}

function closeTextModal(){
  window.location.href = "https://panaca.co"
}

document.addEventListener("click",(e)=>{
  console.log(e.target)
  if(e.target.className == "modal"){
 
  }
})

function popaup(){
/*

  const select = document.querySelector(".contenedor-eventos__select").value;
  if(select ==IdsPasaportes.TERRA || select ==IdsPasaportes.ABIERTO){
   Swal.fire({
            title: 'ESTÁS A UN CLIC DE VIVIR UNA EXPERIENCIA DE DIVERSIÓN COMPLETA EN PANACA',
            html: `Por tu compra entras a PANACA con el Pasaporte Terra y disfruta gratis del espectáculo Travesía. Recuerda que esta promoción es válida en las siguientes fechas:<br><br>
                    <b> Noviembre:</b>19, 21, 23, 26, 28 y 30 <br>
                    <b> Diciembre:</b>3, 5, 10, 11, 12, 13, 14, 15, 17, 18, 19, 20, 21 y 22.<br><br>
                    ¡Te esperamos!<br><br>                                  
                    <b><a target="blank_" href="https://panaca.co/pages/terminos-y-condiciones-pasaporte-terra-travesia"> *Aplican términos y condiciones.</a></b>` 
   });
  }
*/
}

clicksCalendarioPasaportes();
cargarCalendario();
clicsksDocument();
inicializarDatepicker();
fechasDisponibilidadPasaporte("8561613471963");